import { Button, Clickable, Form, H2, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, media, mediaQueries, zIndices } = theme;

const WIDGET_WRAPPER_PADDING = '1rem';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 1.5rem;
`;

export const FormWrapper = styled.div`
  display: flex;
  border-radius: 3rem;
  flex-direction: column;

  ${mediaQueries.above(media.md)} {
    box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.2);
    flex-direction: row;
    width: max-content;
  }

  ${mediaQueries.above(media.lg)} {
    width: max-content;
  }
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MobileButton = styled.div`
  background-color: ${colors.purple};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  padding: 1.5rem;
`;

export const MobileToggleWrapper = styled.div<{ displayMobileToggle: boolean; isDestinationPage?: boolean }>`
  display: ${({ displayMobileToggle }) => (displayMobileToggle ? 'block' : 'none')};
  margin-top: ${({ isDestinationPage }) => (isDestinationPage ? '1rem' : '0')};
`;

export const MobileToggle = styled(Button)<{ displayMobileToggle: boolean; isDestinationPage?: boolean }>`
  align-items: center;
  background-color: ${colors.white};
  border-radius: 85px;
  box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.2);
  display: ${({ displayMobileToggle }) => (displayMobileToggle ? 'flex' : 'none')};
  font-weight: unset;
  height: 100px;
  justify-content: space-between;
  margin: 0 auto;
  min-width: 300px;
  padding: 1rem 1.5rem;
  text-align: left;
  width: 100%;

  ${mediaQueries.above(media.lg)} {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: 1rem;
  margin-top: 1rem;
  margin-bottom: 10rem;
  width: 100%;

  ${mediaQueries.above(media.md)} {
    align-self: center;
    border-radius: 4.5rem;
    margin-left: 2rem;
    padding: 1rem 2rem;
    width: 14rem;
  }
`;

export const StyledH2 = styled(H2)`
  color: ${colors.black};
`;

export const StyledP = styled(P)`
  color: ${colors.grey30};
`;

export const WidgetWrapper = styled.div<{ displayWidget: boolean; isActive: boolean; isDestinationPage?: boolean }>`
  display: ${({ displayWidget }) => (displayWidget ? 'flex' : 'none')};
  background-color: ${colors.white};
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  min-height: 100%;
  min-width: 100dvw;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: ${WIDGET_WRAPPER_PADDING};
  padding-top: 0;
  z-index: ${zIndices.reactModal};

  ${mediaQueries.above(media.md)} {
    display: block;
    min-height: unset;
    min-width: unset;
    width: max-content;
    height: unset;
    overflow: unset;
    padding: 1.5rem;
    padding-bottom: 2.25rem;
    background-color: ${({ isActive }) => (isActive ? colors.white : 'transparent')};
    position: relative;
    z-index: ${({ isActive }) => (isActive ? zIndices.reactModal : 0)};
    border-radius: 1rem;
    max-width: 72.25rem;
    margin-top: ${({ isDestinationPage }) => (isDestinationPage ? '0' : '2rem')};
    margin-bottom: 2rem;
  }

  ${mediaQueries.above(media.lg)} {
    width: unset;
  }

  ${mediaQueries.above(media.xl)} {
    max-width: 76.75rem;
  }
`;

export const OfferTongueWrapper = styled.div<{ displayOffer: boolean }>`
  display: ${({ displayOffer }) => (displayOffer ? 'block' : 'none')};
  ${mediaQueries.above(media.md)} {
    display: block;
    position: absolute;
    top: 3.25rem;
    left: 28rem;
  }

  ${mediaQueries.above(media.lg)} {
    left: 37.25rem;
  }

  ${mediaQueries.above(media.xl)} {
    left: 39.5rem;
  }
`;

export const CloseButton = styled(Clickable)`
  padding-left: 1rem;

  @media (min-width: ${media.md}) {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
`;

export const BackButton = styled(Clickable)`
  padding-right: 1rem;

  ${mediaQueries.above(media.md)} {
    display: none;
  }
`;

export const MenuWrapper = styled.div`
  background-color: ${colors.white};
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;
  padding: 2rem ${WIDGET_WRAPPER_PADDING} 1rem;
  z-index: ${zIndices.reactModal};
  width: calc(100% + (${WIDGET_WRAPPER_PADDING} * 2));
  margin-left: -${WIDGET_WRAPPER_PADDING};

  ${mediaQueries.above(media.md)} {
    width: 100%;
    background-color: unset;
    display: block;
    left: unset;
    position: unset;
    top: unset;
    padding: 0;
    margin-left: 0;
  }
`;

export const LabelSpacer = styled.div`
  margin-bottom: 1rem;
  ${mediaQueries.above(media.md)} {
    margin-bottom: 1.5rem;
  }
`;

export const MobileScrollWrapper = styled.div`
  flex-grow: 1;
  ${mediaQueries.above(media.lg)} {
    flex-grow: unset;
  }
`;

export const StyledForm = styled(Form)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
